
















































import { TvOpportunity } from '@/models/kitchen-tv';
import { OpportunityIcon } from '@/components/opportunities';
import Vue from 'vue';
import moment from 'moment';

export default Vue.extend({
  name: 'OpportunityItem',
  components: {
    OpportunityIcon,
  },
  props: {
    item: Object as () => TvOpportunity,
  },
});
